import {
  Box,
  CardMedia,
  CircularProgress,
  IconButton,
  Typography,
} from "@mui/material";
import React, { useRef, useState } from "react";
import { AddImageToInputIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/AddImageToInputIcon";
import { Close } from "@mui/icons-material";
import { UploadImage } from "./Shared/UploadImage";
import ImagesGallerySelection from "./Shared/ImagesGallerySelection";
import { useBrowseMyGenerations } from "../../../store/Apis/SuitesApps/ImageSuitesApi";

// This variable defines how many recent images to show
const recentItems=20;
interface UploadRecentImagesProps {
  setImageSourceSelected: (image: File | string | null) => void;
}
const UploadRecentImages = ({setImageSourceSelected}: UploadRecentImagesProps) => {
  const { data: myGenerationImagesData, isLoading } = useBrowseMyGenerations({
    page: 1,
    itemsPerPage: recentItems,
  });

  const isExistGenerationImage =
    myGenerationImagesData && myGenerationImagesData.length > 0;
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        justifyContent: "center",
      }}
    >
      {/* upload image */}
      <Box mt={2}>
        <UploadImage setUploadImage={setImageSourceSelected}/>
      </Box>
      {isExistGenerationImage && !isLoading && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
          }}
        >
          <Typography
            sx={{
              color: "var(--M-background117)",
              fontFamily: "Roboto",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 400,
              opacity: 0.7,
              mb: 2,
            }}
          >
            Recent
          </Typography>

          {isLoading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexGrow: 1,
              }}
            >
              <CircularProgress size={50} color="primary" />
            </Box>
          ) : (
            <ImagesGallerySelection imagesData={myGenerationImagesData} setImageSourceSelected={setImageSourceSelected}/>
          )}
        </Box>
      )}
    </Box>
  );
};

export default UploadRecentImages;
